var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher } from "@/schema";
const getNotifications = fetcher.path("/api/notifications").method("get").create();
export function loadNotificationsFromServer() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield getNotifications({});
        return data;
    });
}
const putBatchNotifications = fetcher.path("/api/notifications").method("put").create();
export function updateBatchNotificationsOnServer(request) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield putBatchNotifications({
            notification_ids: request.notification_ids,
            changes: request.changes,
        });
        return data;
    });
}
const getNotificationStatus = fetcher.path("/api/notifications/status").method("get").create();
export function loadNotificationsStatus(since) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield getNotificationStatus({ since: since.toISOString().replace("Z", "") });
        return data;
    });
}
